module.exports = __webpack_public_path__ + "img/PodIcon.5dd5ff99.png";